export default __webpack_public_path__ + "static/c83f43b4-eeb9-4e38-8951-f553ce873be3-1eec9af917dd3b81380739a5a0dea771.woff2";